/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_DesktopInputs */

const en_mk_nav_desktop = /** @type {(inputs: Mk_Nav_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop & connect your computer`)
};

const id_mk_nav_desktop = /** @type {(inputs: Mk_Nav_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop & hubungkan komputer`)
};

/**
* | output |
* | --- |
* | "Desktop & connect your computer" |
*
* @param {Mk_Nav_DesktopInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_desktop = /** @type {((inputs?: Mk_Nav_DesktopInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_DesktopInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_desktop(inputs)
	return en_mk_nav_desktop(inputs)
});